<template>
  <div class="banner">
    <div class="head">
      <div class="info_icon"><img v-lazy="require('@/assets/home/icon2.png')" alt="" /></div>
      <span>COOPERATIVE PARTNER</span>
      <h3>合作伙伴</h3>
    </div>
    <div class="select">
      <el-button @click="selecBtn(1)" :class="isSelct == 1 ? 'activ' : ''">所有合作</el-button>
      <el-button @click="selecBtn(2)" :class="isSelct == 2 ? 'activ' : ''">合作平台</el-button>
      <el-button @click="selecBtn(3)" :class="isSelct == 3 ? 'activ' : ''">合作银行</el-button>
      <el-button @click="selecBtn(4)" :class="isSelct == 4 ? 'activ' : ''">合作公司</el-button>
    </div>
    <div class="aa">
      <vue-seamless-scroll :data="list" :class-option="optionHover" class="seamless-warp"
        :style="{ width: widthData + 'px' }">
        <div class="flexCls">
          <div class="flex_item" v-for="(item, index) in list" :key="index">
            <img :src="item.url" alt="" />
          </div>
        </div>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      //所有合作
      parterList: [
        { url: require("@/assets/company/company1.jpg") },
        { url: require("@/assets/company/company2.jpg") },
        { url: require("@/assets/company/company3.jpg") },
        { url: require("@/assets/company/company4.jpg") },
        { url: require("@/assets/company/company5.jpg") },
        { url: require("@/assets/company/company6.jpg") },
        { url: require("@/assets/company/company7.jpg") },
        { url: require("@/assets/company/company8.jpg") },
        { url: require("@/assets/company/company9.jpg") },
        { url: require("@/assets/company/company10.jpg") },
        { url: require("@/assets/company/company11.jpg") },
        { url: require("@/assets/company/company12.jpg") },
        { url: require("@/assets/company/company13.jpg") },
        { url: require("@/assets/company/company14.jpg") },
        { url: require("@/assets/company/company15.jpg") },
        { url: require("@/assets/company/flat1.jpg") },
        { url: require("@/assets/company/flat2.jpg") },
        { url: require("@/assets/company/flat3.jpg") },
        { url: require("@/assets/company/flat4.jpg") },
        { url: require("@/assets/company/flat5.jpg") },
        { url: require("@/assets/company/flat6.jpg") },
        { url: require("@/assets/company/flat7.jpg") },
        { url: require("@/assets/company/flat8.jpg") },
        { url: require("@/assets/company/flat9.jpg") },
        { url: require("@/assets/company/flat10.jpg") },
        { url: require("@/assets/company/flat11.jpg") },
        { url: require("@/assets/company/flat12.jpg") },
        { url: require("@/assets/company/flat13.jpg") },
        { url: require("@/assets/company/flat14.jpg") },
        { url: require("@/assets/company/flat15.jpg") },
        { url: require("@/assets/company/bank1.jpg") },
        { url: require("@/assets/company/bank2.jpg") },
        { url: require("@/assets/company/bank3.jpg") },
      ],
      // 合作公司
      company: [
        { url: require("@/assets/company/flat1.jpg") },
        { url: require("@/assets/company/flat2.jpg") },
        { url: require("@/assets/company/flat3.jpg") },
        { url: require("@/assets/company/flat4.jpg") },
        { url: require("@/assets/company/flat5.jpg") },
        { url: require("@/assets/company/flat6.jpg") },
        { url: require("@/assets/company/flat7.jpg") },
        { url: require("@/assets/company/company7.jpg") },
        { url: require("@/assets/company/flat8.jpg") },
        { url: require("@/assets/company/flat9.jpg") },
        { url: require("@/assets/company/flat10.jpg") },
        { url: require("@/assets/company/flat11.jpg") },
        { url: require("@/assets/company/flat12.jpg") },
        { url: require("@/assets/company/flat13.jpg") },
        { url: require("@/assets/company/flat14.jpg") },
        { url: require("@/assets/company/flat15.jpg") },
      ],
      // 合作平台
      flat: [
        { url: require("@/assets/company/company1.jpg") },
        { url: require("@/assets/company/company2.jpg") },
        { url: require("@/assets/company/company3.jpg") },
        { url: require("@/assets/company/company4.jpg") },
        { url: require("@/assets/company/company5.jpg") },
        { url: require("@/assets/company/company6.jpg") },
        { url: require("@/assets/company/company8.jpg") },
        { url: require("@/assets/company/company9.jpg") },
        { url: require("@/assets/company/company10.jpg") },
        { url: require("@/assets/company/company11.jpg") },
        { url: require("@/assets/company/company12.jpg") },
        { url: require("@/assets/company/company13.jpg") },
        { url: require("@/assets/company/company14.jpg") },
        { url: require("@/assets/company/company15.jpg") },

      ],
      // 合作银行
      bank: [
        { url: require("@/assets/company/bank1.jpg") },
        { url: require("@/assets/company/bank2.jpg") },
        { url: require("@/assets/company/bank3.jpg") },
        { url: require("@/assets/company/bank4.jpg") },
        { url: require("@/assets/company/bank5.jpg") },
        { url: require("@/assets/company/bank6.jpg") },
      ],
      isSelct: 1,
      list: []
    }
  },
  computed: {
    widthData() {
      return 300 * Number(this.parterList.length);
    },
    optionHover() {
      return {
        step: 2, //数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  created() {

  },
  mounted() { this.selecBtn(1) },
  methods: {
    selecBtn(e) {
      this.isSelct = e
      if (e === 1) {
        this.list = this.parterList
      }
      else if (e === 2) {
        this.list = this.company
      }
      else if (e === 3) {
        this.list = this.bank
      }
      else if (e === 4) {
        this.list = this.flat
      }
    }
  },
}
</script>

<style lang='less' scoped>
.banner {
  margin-top: 76px;
  padding-bottom: 30px;

  .head {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 30px;

    .info_icon {
      width: 120px;
      height: 80px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    span {
      margin-top: 15px;
      font-size: 20px;
    }
  }

  h3 {
    text-align: center;
    margin-top: 15px;
    font-size: 24px;
  }

  .select {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
  }

  .aa {
    margin: 30px auto;
    width: 1200px;
    overflow: hidden;

    .seamless-warp {
      margin: 0 auto;
    }

    .flexCls {
      display: flex;

      .flex_item {
        margin-left: 30px;
        width: 285px;
        height: 115px;

        // height: 300px;
        // margin-left: 30px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}

.el-button {
  border: 1px solid #D8D8D8;
  padding: 10px 30px;
  margin-top: 15px;
  color: #686868;
  font-size: 22px;
}

.activ {
  background-color: #fff;
  color: #ffb520;
  border: 1px solid #ffb520;
}

.el-button:focus,
.el-button:hover {
  background-color: #fff;
  color: #ffb520;
  border: 1px solid #ffb520;
}
</style>